const proxyTargets = {
  dmp: "https://www.dmp.eis-deliverydevqa.cloud",
  dhe: "https://www.dh.eis-deliverydevqa.cloud",
  dmx: "https://www.dmx.eis-deliverydevqa.cloud",
};

const baseURL =
  process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test"
    ? proxyTargets[process.env.REACT_APP_PRODUCT_CODE]
    : "";

export function getAxiosConfig() {
  const axiosConfig = {
    baseURL,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    withCredentials: process.env.NODE_ENV !== "test",
    validateStatus: (status) => status <= 403,
  };

  if (process.env.NODE_ENV === "development") {
    axiosConfig.headers["x-forwarded-host"] = "www.dynahealth.com";
  }
  return axiosConfig;
}
